import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"

const LeaveRules = () => {
    
    return (
        <>
            <Header />
            <Breadcrumb title="Leave Rules" midBreadcrumb="Rules" mainBreadcrumb="Leave Rules" ></Breadcrumb>
            <div className='inner-page'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead" >Leave Rules</h2>
                            <h3 className="subhead">The things that have been most valuable to me I did not learn in school.</h3>
                        </div>
                    </div>
                    <div className="row admission">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">01</h1>
                                    <p className="card-text">Absentees must enter brieﬂy the reason for their absence in the 'Leave
                                        Record' page of Diary. Reason of private nature may be submied through a leave
                                        applicaon. A student's
                                        name will be deleted from the Rolls if he/she is absent for 10 days without inmaon of leave.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">02</h1>
                                    <p className="card-text">If for a serious reason a child is to be taken home, the parent must apply
                                        for it in wring. All exemption/permissions/information, etc. must be sought through the
                                        Principal.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">03</h1>
                                    <p className="card-text">A student will not be sent home with any other person, unless the laer
                                        produces a letter of authorization from the parents.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">04</h1>
                                    <p className="card-text">Leave of absence is granted only on the basis of a prior written application
                                        from the Parent/Guardian, in case of any unforeseen circumstances. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">05</h1>
                                    <p className="card-text">Absence from School for a Test / Examinaon will not be condoned. In case of
                                        emergency. The Principal has to be inmated on the same day, and a Medical Cerﬁcate will have
                                        to be submied. Parents of Student of Classes X and XII should personally submit the leave
                                        applicaon The School does not conduct any retest or re-examinaon.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">06</h1>
                                    <p className="card-text">Repeated absence without leave or unexplained absence for more than 10 days
                                        renders the student liable to have his/her name deleted from the Rolls. Re-admission in the
                                        maer will have to be sought. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">07</h1>
                                    <p className="card-text">A student returning to School after suﬀering from an infectious or contagious
                                        disease should produce a Doctor's cerﬁcate permitting  him / her to resume classes. The student is
                                        also subject to conditions  given below. Student suﬀering from the following must observe the
                                        prescribed period of quarantine before returning to the class.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="card-title">08</h1>
                                    <ul className="list">
                                        <li><strong>Chicken Pox :</strong> 15 days</li>
                                        <li><strong>Measles :</strong> 7 days</li>
                                        <li><strong>Mumps :</strong> 14 days</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default LeaveRules